import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MuteFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.8 3.86L20.12 5.16L5.2 20.06L3.9 18.76L7.3 15.36C6.24 14.18 5.62 12.66 5.62 10.96H7.24C7.24 12.22 7.68 13.36 8.42 14.24L9.54 13.12C9.14 12.54 8.92 11.8 8.92 10.96V6.82C8.92 4.86 10.1 3.48 12.02 3.48C13.94 3.48 15.12 4.86 15.12 6.82V7.54L18.8 3.86ZM12 15.88C14.74 15.88 16.78 13.64 16.78 10.96H18.4C18.4 14.2 16.18 16.84 12.84 17.46V20.38H11.16V15.86C11.42 15.88 11.74 15.88 12 15.88Z" />
    </SvgIcon>
  );
});
